<template>
	<Form ref="formInline" :model="formInline" inline style="text-align: left;margin-top: 1%;">
		<FormItem prop="trackName" :label="$tt('充电站:')" :label-width="100">
			<Select filterable :placeholder="$tt('站点列表')" style="width: 200px;" v-model="formInline.StationId">
				<Option :value='0'>{{$tt('全部')}}</Option>
				<Option v-bind:key="item.StationId" v-for="(item) in StationList" :value="item.StationId">{{item.StationName}}</Option>
			</Select>
		</FormItem>
		<!-- <FormItem :label="$tt('开始时间')" :label-width='70'>
			<DatePicker @on-change="beginChange" style="width: 110px;" type="date" format="yyyy-MM-dd"
				placeholder="Select date" :value="formInline.TimeBegin"></DatePicker>
		</FormItem> -->
		<!-- <FormItem :label="$tt('结束时间')" :label-width='70'>
			<DatePicker @on-change="EndChange" style="width: 110px;" type="date" format="yyyy-MM-dd"
				placeholder="Select date" :value="formInline.TimeEnd"></DatePicker>
		</FormItem> -->
		<FormItem :label="$tt('选择时间')" :label-width='70'>
			<DatePicker style="width: 210px;" type="daterange" format="yyyy-MM-dd" placeholder="Select date"
				v-model="formInline.TimeRange" @on-change="handleChange"></DatePicker>
		</FormItem>
		<FormItem>
			<Button type="primary" @click="$emit('handleSubmit')">{{$tt('查询')}}</Button>
		</FormItem>
	</Form>
</template>

<script>
	import dateFormat from '../../../../../../public/js/comm.js'
	import {
		mapState,
		mapGetters,
		mapActions
	} from 'vuex'
	export default {
		//props: ['param', 'url'],
		data() {
			return {
				formInline: {
					StationId: 0,
					TimeBegin: dateFormat.formatDate(new Date(new Date().getTime() - 1000 * 60 * 60 * 24), 'yyyy-MM-dd'),
					TimeEnd: dateFormat.formatDate(new Date(), 'yyyy-MM-dd'),
					TimeRange: [new Date(new Date().getTime() - 1000 * 60 * 60 * 24), new Date()],
				},
			};
		},
		created() {},
		mounted() {
			// 	this.formInline.TimeBegin = dateFormat.formatDate(new Date(), 'yyyy-MM-dd')
			// 	this.formInline.TimeEnd = dateFormat.formatDate(new Date(), 'yyyy-MM-dd')
		},
		computed: {
			// pageParam: function() {
			// 	const _this = this;
			// 	const param ={
			// 		StationId: _this.formInline.StationId,
			// 		TimeBegin: _this.formInline.TimeBegin==''?'':dateFormat.formatDate(new Date(_this.formInline.TimeBegin), 'yyyy-MM-dd'),
			// 		TimeEnd: _this.formInline.TimeEnd==''?'':dateFormat.formatDate(new Date(_this.formInline.TimeEnd), 'yyyy-MM-dd'),
			// 	}
			// 	return param
			// },
			//直接选属性
			...mapState({
				StationList: 'Stations',
			})
		},
		methods: {
			beginChange: function(stringDate, timeDate) {
				console.log(stringDate);
				this.formInline.TimeBegin = stringDate
			},
			EndChange: function(stringDate, timeDate) {

				this.formInline.TimeEnd = stringDate
			},
			handleChange(date, type) {
				console.log("日期改变：", date, type);
				this.formInline.TimeBegin = date[0];
				this.formInline.TimeEnd = date[1];
			}
		},
	}
</script>

<style>
</style>
